
import {
  CheckCircle2,
  Clock,
  Send,
} from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import type { InvoiceStatus } from '@/lib/types'

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus
}

export function InvoiceStatusBadge({ status }: InvoiceStatusBadgeProps) {
  const styles = {
    paid: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 border-green-200 dark:border-green-800',
    sent: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400 border-blue-200 dark:border-blue-800',
    overdue: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 border-red-200 dark:border-red-800',
    draft: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-400 border-slate-200 dark:border-slate-700',
  }

  const icons = {
    paid: CheckCircle2,
    sent: Send,
    overdue: Clock,
    draft: Clock,
  }

  const Icon = icons[status] || Clock

  return (
    <Badge variant="outline" className={`font-normal ${styles[status]}`}>
      <Icon className="mr-1 h-3 w-3" />
      <span className="capitalize">{status}</span>
    </Badge>
  )
}
